module.exports = __webpack_public_path__ + "assets/img/first-screenshot-mob.978082f2.png";